import { useInRouterContext, useLocation } from 'react-router-dom';
import { WorkmateLoader, type WorkmateScene } from './workmate-loader';
import { workmateSceneForPath } from '@/lib/workmate-scene';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  return (
    <svg
      className={cn('animate-spin text-brand', sizeClasses[size], className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

interface PageLoaderProps {
  scene?: WorkmateScene;
  label?: string;
}

function RoutedPageLoader({ scene, label }: PageLoaderProps) {
  const { pathname } = useLocation();
  const routeScene = workmateSceneForPath(pathname);
  return (
    <WorkmateLoader
      scene={scene ?? routeScene}
      label={label ?? (routeScene === 'juggling' && !scene ? 'Loading page…' : undefined)}
    />
  );
}

export function PageLoader(props: PageLoaderProps = {}) {
  const inRouter = useInRouterContext();
  return inRouter ? <RoutedPageLoader {...props} /> : <WorkmateLoader {...props} />;
}
